import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProjectProfileEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_5228",
		"data-name": "Group 5228",
		transform: "translate(-917 -248)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Primary",
			transform: "translate(917 248)",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_690",
				"data-name": "Rectangle 690",
				width: 24,
				height: 24,
				fill: "rgba(255,255,255,0)"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Path_512",
				"data-name": "Path 512",
				d: "M770.887,510.154c.22-.644.442-1.286.659-1.931.373-1.113.739-2.229,1.119-3.34a1.1,1.1,0,0,1,.252-.406q6.461-6.471,12.93-12.936a1.925,1.925,0,0,1,2.8,0q.824.817,1.642,1.642a1.922,1.922,0,0,1,0,2.778q-6.485,6.49-12.978,12.971a1.143,1.143,0,0,1-.433.244c-1.7.576-3.406,1.143-5.11,1.713a.976.976,0,0,0-.1.047h-.313a.793.793,0,0,1-.468-.468ZM786.821,497.7l-2.668-2.681c-.017.016-.046.042-.073.069q-5.073,5.072-10.142,10.146a.593.593,0,0,0-.14.227q-.619,1.833-1.231,3.67c-.017.051-.024.1-.039.167a.738.738,0,0,0,.079-.013c1.248-.416,2.5-.831,3.744-1.254a.763.763,0,0,0,.284-.191q5.02-5.013,10.037-10.031A.971.971,0,0,1,786.821,497.7Zm.921-.974c.022-.02.057-.047.089-.078q.773-.771,1.545-1.545a.685.685,0,0,0-.011-1.075q-.785-.787-1.572-1.572a.686.686,0,0,0-1.075-.005c-.41.408-.817.819-1.229,1.226-.137.136-.285.262-.415.38Z",
				transform: "translate(-768.887 -488.934)",
				fill: "#14a4b1"
			})]
		})
	})
});
export default SvgProjectProfileEdit;
